import { render, staticRenderFns } from "./ChatReceivedAttachmentsComponent.vue?vue&type=template&id=5f7cb791&"
import script from "./ChatReceivedAttachmentsComponent.vue?vue&type=script&lang=js&"
export * from "./ChatReceivedAttachmentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lpcms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f7cb791')) {
      api.createRecord('5f7cb791', component.options)
    } else {
      api.reload('5f7cb791', component.options)
    }
    module.hot.accept("./ChatReceivedAttachmentsComponent.vue?vue&type=template&id=5f7cb791&", function () {
      api.rerender('5f7cb791', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ChatReceivedAttachmentsComponent.vue"
export default component.exports